import { HttpStatusCodeType } from './http-status-codes';

export interface ProblemDetails {
  status: HttpStatusCodeType;
  title: string;
  detail: string;
  instance?: string;
  type?: string;
  extensions?: Record<string, any>;
}

export const isErrorProblemDetail = (err: any): err is ProblemDetails => {
  if (!err || typeof err === 'string') {
    return false;
  }

  const conditions = [typeof err.status === 'number', typeof err.title === 'string', typeof err.detail === 'string'];

  return conditions.every((c) => c === true);
};
